import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eye, EyeClosed, Gizmo } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { tailwindMerge } from "@air/tailwind-variants";
import { useSortable } from "@dnd-kit/sortable";
import { memo, useMemo } from "react";
import { VISIBILITY_TOGGLE } from "~/constants/testIDs";
import { getSortableItemStyles } from "~/utils/configurableViewFieldsUtils";
export const ViewVisibilityToggleSortable = /*#__PURE__*/ memo((param)=>{
    let { option, prefix, isDraggable, isDragging, ...rest } = param;
    const sortableProps = useSortable({
        id: option.derivedId,
        disabled: !isDraggable
    });
    const style = useMemo(()=>getSortableItemStyles(sortableProps), [
        sortableProps
    ]);
    const renderContent = ()=>/*#__PURE__*/ _jsxs("button", {
            className: tailwindMerge(isDraggable && "w-[calc(100%-1.5rem)]", isDraggable && isDragging && "pointer-events-none"),
            "data-testid": VISIBILITY_TOGGLE,
            "data-field-name": option.fieldName,
            ...rest,
            children: [
                !!prefix ? /*#__PURE__*/ _jsx("div", {
                    className: "mr-2 shrink-0",
                    children: prefix
                }) : null,
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex w-full items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "min-w-0 truncate text-14 font-normal leading-5 tracking-[-0.084px] text-grey-12",
                            children: option.label
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "ml-2 shrink-0 text-grey-10",
                            children: option.isVisible ? /*#__PURE__*/ _jsx(Eye, {
                                "data-testid": "".concat(option.fieldName, "-visible"),
                                width: 16
                            }) : /*#__PURE__*/ _jsx(EyeClosed, {
                                "data-testid": "".concat(option.fieldName, "-not-visible"),
                                width: 16
                            })
                        })
                    ]
                })
            ]
        });
    if (!isDraggable) {
        return renderContent();
    }
    return /*#__PURE__*/ _jsxs("div", {
        ref: sortableProps === null || sortableProps === void 0 ? void 0 : sortableProps.setNodeRef,
        style: style,
        className: tailwindMerge("flex items-center gap-2 py-2 pr-1.5", isDragging && "cursor-grabbing"),
        ...sortableProps === null || sortableProps === void 0 ? void 0 : sortableProps.attributes,
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                className: tailwindMerge("shrink-0", isDragging && "cursor-grabbing"),
                icon: Gizmo,
                appearance: "ghost",
                color: "grey",
                size: "small",
                label: "Move",
                ...sortableProps === null || sortableProps === void 0 ? void 0 : sortableProps.listeners
            }),
            renderContent()
        ]
    });
});
ViewVisibilityToggleSortable.displayName = "ViewVisibilityToggleSortable";
